module.exports = __webpack_public_path__ + "static/media/antigua-beaches-3.427ad614.jpg";